import React from "react";

export default function SettingItem({
                                        icon,
                                        title,
                                        description,
                                        children,
                                        warning = false
                                    }) {
    return (
        <div
            className="rounded-lg border dark:border-gray-600 border-gray-200 p-6 hover:shadow-md transition-shadow duration-200 mb-2">
            <div className="flex md:flex lg:flex xl:flex items-center justify-between flex-wrap">
                <div className="flex items-center space-x-3 flex-1">
                    {icon && (<div className={`p-2 rounded-lg ${warning ? 'bg-yellow-100' : 'bg-blue-100'}`}>
                        <div className={warning ? 'text-yellow-600' : 'text-blue-600'}>
                            {icon}
                        </div>
                    </div>)}

                    <div className="flex-1">
                        <h3 className="text-lg font-semibold  mb-1">{title}</h3>
                        <p className=" text-sm leading-relaxed">{description}</p>
                    </div>
                </div>

                <div className="hidden md:flex w-px h-16 bg-gray-200 dark:bg-gray-700 mx-6"></div>

                <div className="flex-shrink-0 flex items-center justify-center">
                    {children}
                </div>
            </div>
        </div>
    );
};
